"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _GroupedItemList = _interopRequireDefault(require("./GroupedItemList"));

var DropdownGroupedItemList = function DropdownGroupedItemList(_ref) {
  var classes = _ref.classes,
      items = _ref.items,
      customItem = _ref.customItem,
      hideEmptyGroup = _ref.hideEmptyGroup;
  return (0, _preact.h)("div", {
    className: classes
  }, customItem, items.map(function (_ref2) {
    var items = _ref2.items,
        groupName = _ref2.groupName;

    if (hideEmptyGroup && !items.length) {
      return null;
    }

    return (0, _preact.h)(_GroupedItemList.default, {
      key: groupName,
      groupName: groupName,
      items: items
    });
  }));
};

var _default = DropdownGroupedItemList;
exports.default = _default;